import { Card, Typography, Divider, Link, Stack, Avatar } from "@mui/material";
import AvatarGroup from "@mui/material/AvatarGroup"; // Import AvatarGroup
import StarIcon from "@mui/icons-material/Star"; // Import Star icon
import { motion, AnimatePresence } from "framer-motion";

const CustomerReviewInfoCard = ({
  title,
  customerCount,
  ratingText,
  ratingValue,
  totalReviews,
  avatarUrls,
}) => {
  const numberOfStarsDisplayed = 5;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={title}
        initial={{ opacity: 0.4, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.1, y: 20 }}
        transition={{ duration: 0.5 }}
      >
        <Card
          sx={{
            p: 3,
            borderRadius: 3,
            border: "1px solid",
            borderColor: "border.lighter",
            boxShadow: "none",
            bgcolor: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Avatar Group */}
          {avatarUrls && avatarUrls.length > 0 && (
            <AvatarGroup
              max={4}
              sx={{ mb: 2, "& .MuiAvatar-root": { width: 40, height: 40 } }}
            >
              {avatarUrls.map((url, index) => (
                <Avatar key={index} alt={`Customer ${index + 1}`} src={url} />
              ))}
            </AvatarGroup>
          )}
          {/* Happy Customers Count */}
          <Typography
            variant="body1"
            color="text.primary"
            sx={{ fontWeight: "bold", mb: 1 }}
          >
            {customerCount} Happy Customers
          </Typography>

          {/* Rating Details (Excellent ⭐⭐⭐⭐⭐ 4.8 / 5) */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            sx={{ mb: 2 }}
          >
            <Typography variant="body" color="text.secondary">
              {ratingText}
            </Typography>

            {/* Render Star Icons */}
            {[...Array(numberOfStarsDisplayed)].map((_, index) => (
              <StarIcon
                key={index}
                sx={{ color: "button.star", fontSize: "1.21rem" }}
              />
            ))}

            <Typography variant="body2" color="text.secondary">
              {ratingValue}
            </Typography>
          </Stack>

          {/* <Divider sx={{ width: "100%", mb: 2 }} /> */}

          {/* Total Reviews */}
          {/* <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="body" color="text.main">
              Based on
            </Typography>
            <Link
              href="#"
              underline="always"
              sx={{ fontSize: "0.875rem", color: "button.link" }}
            >
              <Typography variant="body">{totalReviews} reviews</Typography>
            </Link>
          </Stack> */}
        </Card>
      </motion.div>
    </AnimatePresence>
  );
};

export default CustomerReviewInfoCard;
